import React from 'react';
import Navigation from '../../components/common/Navigation';
import { useHistory } from 'react-router-dom';
import HeaderContainer from '../../containers/common/HeaderContainer';
import { SideSpacer } from '../../components/common/Spacer';
import {
  CommonContainer,
  HorizonWrapper,
} from '../../components/common/Container';
import PetslookSmartStoreContainer from '../../containers/smartstore/PetslookSmartStoreContainer';

const PetslookSmartStorePage = () => {

  return (
    <>
      <HeaderContainer />
      <Navigation />
      <SideSpacer>
        <HorizonWrapper>
          <CommonContainer style={{width: '1510px', margin: '0 75px'}}>
              <PetslookSmartStoreContainer />
          </CommonContainer>
        </HorizonWrapper>
      </SideSpacer>
    </>
  );
};

export default PetslookSmartStorePage;

